import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { College } from '../models/college.model';
import { PatchDocument } from '../models/dto.model';

@Injectable({
  providedIn: 'root',
})
export class CollegeService {
  path = '/api/College';
  updateableProperties: string[] = ['name', 'emailDomain', 'status'];

  constructor(protected http: HttpClient) {}

  getAllColleges(): Observable<any> {
    return this.http.get(`${environment.API}${this.path}`);
  }

  createCollege(body: College) {
    return this.http.post<College>(`${environment.API}${this.path}`, body);
  }

  deleteCollege(id: any) {
    return this.http.delete(`${environment.API}${this.path}/${id}`);
  }

  updatedCollege(body: College): Observable<College> {
    const patchDoc = this.toPatchDoc(body);
    return this.http.patch<College>(
      `${environment.API}${this.path}/${body.id}`,
      patchDoc,
      {
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      }
    );
  }

  protected toPatchDoc(object: College): PatchDocument[] {
    let doc: PatchDocument[] = [];

    if (this.updateableProperties) {
      for (const [key, value] of Object.entries(object)) {
        if (this.updateableProperties.includes(key)) {
          doc.push({
            op: 'replace',
            path: `/${key}`,
            value: value,
          });
        }
      }
    }

    return doc;
  }
}
